<template>
  <div>
    <div class="header page-header">
      <div>IMPORT</div>
      <p>New Import</p>
    </div>
    <div class="card">
      <div class="form">
        <div class="form__group form__group--inline">
          <label class="btn btn__primary" for="file">Browse</label>
          <!-- fa asta sa arate ca un button :D -->
          <input 
            class="input input__underline" 
            :placeholder="file ? file.name : 'Select a file'"
          />
          <input
            name="Browse"
            placeholder="Type name here.."
            type="file"
            id="file"
            value="Select a file"
            ref="file"
            v-on:change="handleFileUpload"
            style="visibility:hidden; position: absolute"
          />
        </div>
        <div class="clearfix download-sanple">
            <span style="font-size: 14px;">Download sample file</span>
            <a class="btn btn__primary btn__primary--outline" for="file" @click="downloadSampleFile('csv')">CSV</a> 
            <a class="btn btn__primary btn__primary--outline" for="file" @click="downloadSampleFile('xml')">XML</a>
        </div>
      </div>
      <div class="form__actions">
        <Button
          class="btn btn__primary"
          text="Upload To Queue"
          style="display: block; margin-left: auto;"
          @on-click="createImport"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../partials/Button.vue";
import * as api from "./api.js";
import  axios from 'axios';

export default {
  name: "CreateImport",
  components: {
    Button
  },
  created: function() {
    document.title = "Add Import | PayGate Invoice";
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    createImport: async function() {
      try {
        let data = new FormData();
        data.append("fileToUpload", this.file);
        await api.createImport(data);
        this.$toasted.success("Import added successfully", {
          className: "success-toast"
        });
        this.$router.push("/dashboard/imports");
      } catch (e) {
        this.error = "error";
        let err_msg = "Something went wrong";
        Object.keys(e.response.data.errors).map(
          key => (err_msg = e.response.data.errors[key][0])
        );
        this.$toasted.error(err_msg, { className: "error-toast" });
      }
    },
    forceFileDownload(response, type){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.sampleFileName[type]) //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadSampleFile( type ) {
      console.log(this.sampleFileName[type]);
      axios({
        method: 'get',
        url: process.env.VUE_APP_APP_URL + '/' + this.sampleFileName[type],
        responseType: 'arraybuffer'
      })
      .then(response => {
        
        this.forceFileDownload(response, type)
        
      })
      .catch(() => console.log('error occured'))
    }
  },
  data() {
    return {
      file: "",
      sampleFileName: {
        'csv': "PayGate Invoice, Sample import csv.csv",
        'xml': "PayGate Invoice, Sample import xml.xml",
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  align-items: flex-end;
}

.button-container {
  display: flex;
  justify-content: flex-end;
}

.download-sanple {
  margin-top: 12px;
  font-size: 14px;
}

.download-sanple .btn {
    padding: 2px 12px;
    margin-left: 10px;
}
</style>